import type {FC} from 'react'
import LogbookTable from './Components/LogbookTable'

const LogbookEntryComponent: FC = () => <LogbookTable />

export default LogbookEntryComponent
